module.exports = __webpack_public_path__ + "Flama-SemiboldItalic.woff?0d0ec0b625c3ab44626f644471a7c818";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-SemiboldItalic.woff
// module id = 903
// module chunks = 0